/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Globalattributes } from '../../models/globalattributes';

export interface ReportParamGetglobalattributes$Params {
}

export function reportParamGetglobalattributes(http: HttpClient, rootUrl: string, params?: ReportParamGetglobalattributes$Params, context?: HttpContext): Observable<StrictHttpResponse<Globalattributes>> {
  const rb = new RequestBuilder(rootUrl, reportParamGetglobalattributes.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Globalattributes>;
    })
  );
}

reportParamGetglobalattributes.PATH = '/api/ReportParam/reportparm/getglobalattributes';
